export enum mediaQuery {
  DESKTOP = '(min-width: 1367px)',
  NOTEBOOK = '(max-width: 1366px) and (min-width: 1281px)',
  TABLET = '(max-width: 1280px) and (min-width: 801px)',
  MOBILE = '(max-width: 800px)',
}
